jQuery(document).ready(function($) {

  /* Get current page URL */
  var curr_url = window.location.href;

  /* Check screen width */
  var curr_screen_width = $( window ).width();
  var tablet_screen = curr_screen_width < 960;
  var mobile_screen = curr_screen_width < 768;

  /* Show/hide floating booking btn */
  showHideBookingBtn();
  
  /* Resize instagram widget images */
  setTimeout(function(){ resizeInstagramWidgetImgs(); }, 1200);
  
  /* If Instagram feed is broken, hide the section... */
  setTimeout(function(){ $('.shopify-section.social-feeds:contains("invalid")').fadeOut(); }, 1200);

  /* Check various things on screen resize */
  $( window ).resize(function() {
    /* Show/hide Google reCAPTCHA */
    showHideBookingBtn();
    /* Resize instagram widget images */
    resizeInstagramWidgetImgs();
  });

  /* Check various things on screen scroll */
  $( window ).scroll(function() {
    /* Show/hide Google reCAPTCHA */
    showHideBookingBtn();
  });
  
  
  /**
   * Resize Instagram widget image heights based on their width (responsively)
   */
  function resizeInstagramWidgetImgs() {
    $('.instagram-widget .items .item').each(function(){
      $(this).height( $(this).width() );
    });
  }

  /**
   * Show/hide reCAPTCHA as user scrolls a form into view... 
   * Currently integrated into Contact Form 7 forms.
   */
  function showHideBookingBtn(){
    /* Set initial flag, to enter loop */
    var exitLoop = false;
    /* For each Book Now button found in '.main-content', check if scrolled into view */
    $('.main-content a.button:contains("Book Online")').each(function() {
      if (isScrolledIntoView(this) && !exitLoop) {
        /* If in view, hide the element */
        $('.floating-booking-btn').fadeOut();
        /* Exit the loop, in case multiple forms exist and one isn't in view... */
        exitLoop = true;
      } else if (!exitLoop) {
        /* Else not in view, show the element */
        $('.floating-booking-btn').fadeIn();
      }
    });
  }

  /**
   * Check if element is in viewport... 
   * Requires element to be passed in...
   */
  function isScrolledIntoView(elem) {
    if ( $(elem).length > 0 ) {
      var elementTop = $(elem).offset().top;
      var elementBottom = elementTop + $(elem).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    } else {
      return false;
    }
  }


});